import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FirmaRapida } from '../models/FirmaRapida.model';


type requestBody = {
  method: string
  data?: FirmaRapida,
  id?: string,
  idCompany?: string,
  user?: string,
  subdomain?: string
}


@Injectable({
  providedIn: 'root'
})
export class FirmaRapidaService {

    private urlFirmaRapida:string = `${environment.apiCore}/process-firmfast/`;

    constructor( private http: HttpClient ) { }

    obtenerNumeroExpediente(empresa:string, subdomain:string, user:string):Observable<any> {
        const body:requestBody = {
            method: 'POST-EXPEDIENT-NUMBER', 
            user:user, 
            subdomain:subdomain, 
            idCompany:empresa, 
            data: { statusExpedientNumber: true }
        }
        return this.http.post(this.urlFirmaRapida, body, { headers: { "x-api-key": environment.xApiKey } })
    }

    crearProceso(empresa:string, subdomain:string, user:string, data:any) {
        const body:requestBody = {
            method: 'PROCESS-FIRMFAST',
            user: user,
            subdomain: subdomain,
            idCompany: empresa,
            data: data
        }
        return this.http.post(this.urlFirmaRapida, body, { headers: { "x-api-key": environment.xApiKey } })
    }

    cargar(empresa:string, subdomain:string, user:string, data:any):Observable<any> {
        const body:requestBody = {
            method: 'PROCESS-UPLOAD',
            user: user,
            subdomain: subdomain,
            idCompany: empresa,
            data: data
        }
        return this.http.post(this.urlFirmaRapida, body, { headers: { "x-api-key": environment.xApiKey } })
    }

    listarDocumentos(empresa:string, subdomain:string, user:string, idProcess:string):Observable<any[]> {
        const body:requestBody = {
            method: 'LIST-DOCUMENT',
            user: user,
            subdomain: subdomain,
            idCompany: empresa,
            data: { idProcess:idProcess }
        }
        return this.http.post<any[]>(this.urlFirmaRapida, body, { headers: { "x-api-key": environment.xApiKey } })
    }

    eliminarDocumento(empresa:string, subdomain:string, user:string, idProcess:string, id:string) {
        const body:requestBody = {
            method: 'DELETE',
            user: user,
            subdomain: subdomain,
            idCompany: empresa,
            data: { idProcess:idProcess, id:id }
        }
        return this.http.post(this.urlFirmaRapida, body, { headers: { "x-api-key": environment.xApiKey } })
    }

    finalizar(empresa:string, subdomain:string, user:string, idProcess:string, quantityDocument:number) {
        const body:requestBody = {
            method: 'PROCESS-FINALIZE',
            user: user,
            subdomain: subdomain,
            idCompany: empresa,
            data: { idProcess:idProcess, quantityDocument:quantityDocument }
        }
        return this.http.post(this.urlFirmaRapida, body, { headers: { "x-api-key": environment.xApiKey } })
    }
}
